import React, { Component } from 'react';
import SeatNum from '../../seat/seatNum';

class StudentInfoBtn extends Component {
    render() {
        return (
            <div className="d-flex align-items-center left student-info">
                <div className="student-number d-flex flex-column justify-content-center align-items-center"><SeatNum Sitnum={this.props.Sitnum} /></div>
                <button className="student-text info-open-btn btn d-flex flex-column ml-2" onClick={this.props.onOpen}><strong>응시번호: {this.props.mb_id}</strong><strong>성명:{this.props.mb_name}</strong></button>
            </div>
        );
    }
}

export default StudentInfoBtn;